import { createExperimentHook } from '@prisjakt/ui-experiment';

export const useChangelogPositionExperiment = createExperimentHook(
  'changelog-position',
  true,
  { alternate: false }
);

export type SearchResultLayoutExperimentType =
  | boolean
  | 'wide'
  | 'without panorama'
  | 'wide and without panorama';

export const useSearchResultLayoutExperiment = createExperimentHook<
  SearchResultLayoutExperimentType
>('search-result-layout', false, {
  wide: 'wide',
  withoutPanorama: 'without panorama',
  wideAndWithoutPanorama: 'wide and without panorama',
});

export type PanoramaAdInContentExperimentType =
  | boolean
  | 'trailing skyscraper without top panorama ad'
  | 'trailing skyscraper without top panorama ad with panorama ad in content';

export const usePanoramaAdInContentExperiment = createExperimentHook<
  PanoramaAdInContentExperimentType
>('panorama-ad-in-content', false, {
  trailingSkyscraperWithoutTopPanoramaAd:
    'trailing skyscraper without top panorama ad',
  trailingSkyscraperWithoutTopPanoramaAdWithPanoramaAdInContent:
    'trailing skyscraper without top panorama ad with panorama ad in content',
});

export type MobileTopAdExperimentType =
  | boolean
  | 'no top ad + lift ad in price list'
  | 'no top ad';

export const useMobileTopAdExperiment = createExperimentHook<
  MobileTopAdExperimentType
>('mobile-top-ad-experiment', false, {
  removeTopAdPlus: 'no top ad + lift ad in price list',
  removeTopAd: 'no top ad',
});

export const useOurChoiceExperiment = createExperimentHook(
  'our-choice-experiment',
  false,
  {
    enabled: true,
  }
);

export type ListCardClickoutExperimentType =
  | boolean
  | 'clickout and list default'
  | 'list default';

export const useListCardClickoutExperiment = createExperimentHook<
  ListCardClickoutExperimentType
>('list-card-clickout', false, {
  clickoutAndListDefault: 'clickout and list default',
  listDefault: 'list default',
});

export const useNewCategoryComponentKWLP = createExperimentHook(
  'new-cat-component-kwlp',
  false,
  {
    new: true,
  }
);
